<template>
  <div>
    <div class="x-oilBox" v-if="goods">
      <div class="border"></div>
      <div class="middle flex">
        <div class="imgBox"><img :src="goods.mainImage" /></div>
        <div class="flex1">
          <div
            class="title"
            v-html="goods.name.replace(/(\r\n|\n|\r)/, '<br />')"
          ></div>
          <div class="spec">规格：{{ goods.volume }}</div>
          <div class="money">
            ￥<span style="font-size: 16px"
              >{{ goods.price }}/{{ goods.unitName }}</span
            >
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>
    <div style="margin-bottom: 50px;">
      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="vux-1px-b">
          <x-input
            :title="title1"
            text-align="right"
            placeholder="输入订购数量"
            v-model="params.quantity"
            placeholder-align="right"
          ></x-input>
        </div>

        <div class="vux-1px-b">
<!--          <selector-->
<!--            title="订购主体"-->
<!--            direction="rtl"-->
<!--            placeholder="请选择订购主体"-->
<!--            v-model="params.clientType"-->
<!--            :options="typeList"-->
<!--          ></selector>-->
          <van-field
                  readonly
                  clickable
                  label="订购主体"
                  input-align="right"
                  :value="clientTypeName"
                  placeholder="请选择订购主体"
                  @click="showPicker = true"
          />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="typeList"
                    value-key="label"
                    @cancel="showPicker = false"
                    @confirm="clientTypeConfirm"
            />
          </van-popup>
        </div>
        <div class="vux-1px-b" @click="openShowPageList">
          <x-input
            title="买家"
            text-align="right"
            disabled="disabled"
            placeholder="请选择买家"
            v-model="params.contactName"
            placeholder-align="right"
          >
          </x-input>
        </div>
        <div
          class="vux-1px-b"
          v-if="params.clientType == 2"
          @click="showContactList = true"
        >
          <x-input
            title="联系人"
            text-align="right"
            disabled="disabled"
            placeholder="请选择联系人"
            v-model="contactName"
            placeholder-align="right"
          >
          </x-input>
        </div>
        <div class="vux-1px-b" v-if="params.contactName">
          <x-input
            title="联系方式"
            text-align="right"
            disabled="disabled"
            placeholder="输入联系方式"
            v-model="params.contactPhone"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
<!--          <selector-->
<!--            title="渔船编号"-->
<!--            direction="rtl"-->
<!--            v-model="params.shipId"-->
<!--            :options="shipList"-->
<!--          ></selector>-->
          <van-field
                  readonly
                  clickable
                  label="渔船编号"
                  input-align="right"
                  :value="shipName"
                  placeholder="请选择渔船编号"
                  @click="showShipPicker = true"
          />
          <van-popup v-model="showShipPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="shipList"
                    value-key="label"
                    @cancel="showShipPicker = false"
                    @confirm="shipConfirm"
            />
          </van-popup>
        </div>
        <div class="vux-1px-b">
<!--          <selector-->
<!--            title="付款方式"-->
<!--            direction="rtl"-->
<!--            v-model="params.paymentMethod"-->
<!--            :options="payMethodsList"-->
<!--          ></selector>-->
          <van-field
                  readonly
                  clickable
                  label="付款方式"
                  input-align="right"
                  :value="paymentName"
                  placeholder="请选择付款方式"
                  @click="showPaymentPicker = true"
          />
          <van-popup v-model="showPaymentPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="payMethodsList"
                    value-key="label"
                    @cancel="showPaymentPicker = false"
                    @confirm="paymentConfirm"
            />
          </van-popup>
        </div>
<!--        <div class="vux-1px-b" v-if="params.paymentMethod == 1">-->
<!--          <selector-->
<!--            title="*付款人"-->
<!--            direction="rtl"-->
<!--            v-model="params.clientId"-->
<!--            :options="shareShipList"-->
<!--          ></selector>-->
<!--        </div>-->
<!--        <div class="vux-1px-b" v-if="params.paymentMethod == 1">-->
<!--          <selector-->
<!--            title="*付款银行卡"-->
<!--            direction="rtl"-->
<!--            v-model="params.bankId"-->
<!--            :options="bankList"-->
<!--          ></selector>-->
<!--        </div>-->
        <div>
          <checklist
            :options="commonList"
            required="true"
            v-model="checkType"
            :max="1"
            @on-change="change"
          ></checklist>
        </div>
        <div class="vux-1px-b" v-if="params.type == 1">
          <datetime
            placeholder="请选择时间"
            format="YYYY-MM-DD HH:mm"
            v-model="params.useTime"
            title="用油时间"
          ></datetime>
        </div>
        <div class="vux-1px-b">
          <x-input
            title="经度"
            text-align="right"
            placeholder="请输入"
            v-model="params.longitude"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
          <x-input
            title="纬度"
            text-align="right"
            placeholder="请输入"
            v-model="params.latitude"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
<!--          <selector-->
<!--            title="溯源"-->
<!--            direction="rtl"-->
<!--            v-model="params.origin"-->
<!--            :options="originList"-->
<!--          ></selector>-->
          <van-field
                  readonly
                  clickable
                  label="溯源"
                  input-align="right"
                  :value="originName"
                  placeholder="请选择溯源"
                  @click="showOriginPicker = true"
          />
          <van-popup v-model="showOriginPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="originList"
                    value-key="label"
                    @cancel="showOriginPicker = false"
                    @confirm="originConfirm"
            />
          </van-popup>
        </div>
        <div v-if="params.type == 1">
          <x-textarea title="用油地址" v-model="params.address"></x-textarea>
        </div>
      </div>
      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="vux-1px-b">
          <x-textarea
            title="订单备注"
            text-align="right"
            placeholder="输入备注"
            v-model="params.remark"
            placeholder-align="right"
          ></x-textarea>
        </div>
        <div class="heji vux-1px-b" v-if="params.type != 1">
          <span style="margin-right: 5px">合计金额:</span>¥{{ total }}
        </div>
        <div class="vux-1px-b">
          <datetime
            placeholder="请选择时间"
            format="YYYY-MM-DD HH:mm"
            v-model="params.deadLine"
            title="截止时间"
          ></datetime>
        </div>
      </div>

      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="uploadImgBox">
          <div>上传合同</div>
          <upload-file v-model="params.contractImg"> </upload-file>
        </div>
      </div>
    </div>
    <div class="footer flex">
      <div class="flex1">
        <span v-if="params.type == 1">
          <span class="footerLine1">合计：</span>
          <span style="color: #FF3600">¥{{ total }}</span>
        </span>
        <span v-else>
          <span class="footerLine1"
            >预付：<span style="color: #FF3600">￥</span></span
          >
          <input
            class="yufu"
            v-model="params.prepaidAmount"
            @change="prepaidAmountChange"
          />
        </span>
      </div>
      <div class="buyButton" @click="validate">新增订单</div>
    </div>
    <confirm
      v-model="show"
      title="提示"
      content="请确认信息无误，是否购买？"
      @on-confirm="onConfirm"
    >
    </confirm>

    <pageList
      class="customer"
      v-if="showPageList"
      :type="params.clientType"
      @change="onUserChange"
      @close="closeBox"
    ></pageList>

    <contactList
      class="customer"
      v-if="showContactList"
      :companyId="companyId"
      @change="contactChange"
      @close="closeContactList"
    ></contactList>
  </div>
</template>

<script>
import { getAdminProductDetail } from "@/api/goods";
import { useApi } from "@/hooks";
import { getAdminClientShipList, getPayerList } from "@/api/ship";
import { tempOrderCreate } from "@/api/order";
import { orderPaymentMethod } from "../../api/order";
import { Checklist } from "vux";
import pageList from "@/components/pageList/pageList";
import contactList from "@/components/contactList/contactList";
import UploadFile from "@/components/Upload/UploaderFile";
import { BigNumber } from 'bignumber.js'

const rules = {
  quantity: "required|numeric",
  // contactName: "required",
  // contactPhone: "required",
  // shipId: "required",
  // clientId: "required",
  // useTime: "required"
  // address: "required"
  type: "required"
};

const attrs = {
  quantity: "数量",
  // contactName: "买家",
  // contactPhone: "手机",
  shipId: "渔船编号",
  type: "付款类型"
  // clientId: "付款人",
  // useTime: "用油时间",
  // address: "用油地址"
};

export default {
  name: "newOrder",
  props: {
    id: {
      type: String
    }
  },
  components: {
    Checklist,
    pageList,
    contactList,
    UploadFile
  },
  data() {
    return {
      originList: [
        { value: 1, label: "默认" },
        { value: 2, label: "溯源" }
      ],
      commonList: [
        { key: "1", value: "立即付款" },
        { key: "2", value: "预定付款（提前预定，随时用）" }
      ],
      goods: null,
      show: false,
      shipList: [],
      shareShipList: [],
      bankList: [],
      typeList: [
        {
          value: "1",
          label: "个人"
        },
        {
          value: "2",
          label: "公司"
        }
      ],
      payMethodsList: [],
      params: {
        address: "",
        bankId: "",
        clientId: "",
        clientType: 1,
        companyId: "",
        contactClientId: "",
        contactName: "",
        contactPhone: "",
        deadLine: "",
        orderAmount: "",
        paymentMethod: "",
        prepaidAmount: "",
        remark: "",
        shipId: "",
        type: 1,
        useTime: "",
        goodsDetails: [],
        quantity: "",
        origin: 1
      },
      title1: "",
      showPageList: false,
      showContactList: false,
      contactName: "",
      clientId: "",
      companyId: "",
      checkType: "1",

      clientTypeName:'',
      showPicker:false,

      shipName:'',
      showShipPicker:false,

      paymentName:'',
      showPaymentPicker:false,

      originName:'默认',
      showOriginPicker:false,
    };
  },
  computed: {
    total() {
      if (this.goods && this.params.quantity > 0) {
        return new BigNumber(this.goods.price).multipliedBy(this.params.quantity).toFixed(2);
      } else {
        return 0;
      }
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    let myDate = new Date();
    let endTime =
      myDate.getFullYear() +
      "-" +
      (myDate.getMonth() + 1) +
      "-" +
      myDate.getDate() +
      " 23:59";
    this.params.deadLine = endTime;
    this.fetchDetail();
    this.fetchPaymentMethod();
  },
  watch: {
    "params.quantity"(e) {
      if (this.goods && this.params.quantity > 0) {
        this.params.prepaidAmount = ((e * this.goods.price) / 2).toFixed(2);
        // this.params.orderAmount = (e * this.goods.price).toFixed(2);
        this.params.orderAmount = new BigNumber(this.goods.price).multipliedBy(e).toFixed(2)
      } else {
        this.params.prepaidAmount = 0;
        this.params.orderAmount = 0;
      }
    },
    "params.clientType"() {
      this.params.contactName = "";
      this.params.contactPhone = "";
      this.params.shipId = "";
      this.params.companyId = "";
      this.companyId = "";
      this.contactName = "";
      this.fetchPaymentMethod();
    }
  },
  methods: {
    clientTypeConfirm(e){
      this.clientTypeName=e.label
      this.params.clientType=e.value
      this.showPicker=false
    },
    shipConfirm(e){
      this.shipName=e.label
      this.params.shipId=e.value
      this.showShipPicker=false
    },
    paymentConfirm(e){
      this.paymentName=e.label
      this.params.paymentMethod=e.value
      this.showPaymentPicker=false
    },
    originConfirm(e){
      this.originName=e.label
      this.params.origin=e.value
      this.showOriginPicker=false
    },
    contactChange(e) {
      this.contactName = e.name;
      this.params.contactClientId = e.clientId;
      this.params.contactPhone = e.phone;
      this.showContactList = false;
    },
    closeContactList(state) {
      this.showContactList = state;
    },
    onUserChange(res) {
      this.showPageList = false;
      this.contactName = "";
      this.params.contactName = res.name;
      if (this.params.clientType == 1) {
        this.params.contactClientId = res.clientId;
        this.clientId = res.clientId;
        this.params.contactPhone = res.phone;
        this.companyId = "";
        this.params.companyId = "";
      } else {
        this.params.contactClientId = "";
        this.clientId = "";
        this.params.contactPhone = "";
        this.companyId = res.companyId;
        this.params.companyId = res.companyId;
      }

      this.fetchShipList();
    },
    closeBox(state) {
      this.showPageList = state;
    },
    openShowPageList() {
      let that = this;
      document.activeElement.blur();
      setTimeout(function() {
        that.showPageList = true;
      }, 200);
    },
    prepaidAmountChange(e) {
      if (e.target.value < this.params.quantity * this.goods.price * 0.2) {
        this.params.prepaidAmount = (
          this.params.quantity *
          this.goods.price *
          0.2
        ).toFixed(2);
      } else if (e.target.value > this.params.quantity * this.goods.price) {
        this.params.prepaidAmount = (
          this.params.quantity * this.goods.price
        ).toFixed(2);
      } else {
        this.params.prepaidAmount = e.target.value;
      }
    },
    change(val) {
      if (val.length > 0) {
        this.params.type = val[0];
        if (this.params.type != 1) {
          this.params.address = "";
          this.params.useTime = "";
        }
      } else {
        this.params.type = "";
        this.params.address = "";
        this.params.useTime = "";
      }
    },
    fetchPaymentMethod() {
      orderPaymentMethod()
        .then(res => {
          this.payMethodsList = res.map(x => {
            return {
              value: x.value,
              label: x.name
            };
          });

          if (this.payMethodsList.length > 0 && !this.params.paymentMethod) {
            this.params.paymentMethod = this.payMethodsList[0].value;
            this.paymentName= this.payMethodsList[0].label;
          }
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    validate() {
      this.$validate(this.params, rules, attrs)
        .then(() => {
          if (this.checkType == 1) {
            if (
              this.params.clientType == 2 &&
              this.params.contactName &&
              !this.params.contactClientId
            ) {
              this.$showError("请选择联系人");
            } else {
              if (!this.params.useTime) {
                this.$showError("请选择用油时间");
              } else if (!this.params.address) {
                this.$showError("请输入用油地址");
              } else {
                this.show = true;
              }
            }
          } else {
            this.show = true;
          }
        })
        .catch(e => {
          this.$showError(e, "warn");
        });
    },
    onConfirm() {
      const goodsDetails = [
        {
          discountPrice: "",
          discountTotalPrice: "",
          fee: 0,
          id: "",
          image: "",
          name: "",
          price: "",
          quantity: "",
          totalPrice: "",
          unitName: "",
          unitValue: "",
          version: "",
          volume: ""
        }
      ];
      goodsDetails[0].discountPrice = this.goods.price;
      goodsDetails[0].discountTotalPrice = this.total;
      goodsDetails[0].id = this.goods.id;
      goodsDetails[0].name = this.goods.name;
      goodsDetails[0].image = this.goods.mainImage;
      goodsDetails[0].price = this.goods.price;
      goodsDetails[0].quantity = this.params.quantity;
      goodsDetails[0].totalPrice = this.total;
      goodsDetails[0].unitName = this.goods.unitName;
      goodsDetails[0].unitValue = this.goods.unitValue;
      goodsDetails[0].version = this.goods.version;
      goodsDetails[0].volume = this.goods.volume;

      this.params.goodsDetails = goodsDetails;
      this.$vux.loading.show();
      tempOrderCreate(this.params)
        .then(res => {
          this.$vux.loading.hide();
          this.$router.push("/order/shareOrder/" + res.id);
        })
        .catch(error => {
          this.$vux.loading.hide();
          this.$showError(error, "warn");
        });
    },
    fetchPayerList() {
      return getPayerList({
        shipId: this.params.shipId,
        paymentMethod: this.params.paymentMethod,
        type: this.params.clientType
      }).then(res => {
        const bbb = res.map(x => {
          return {
            key: x.clientId,
            value: x.clientName,
            clientId: x.clientId
          };
        });
        this.shareShipList = [];
        this.shareShipList = this.shareShipList.concat(bbb);
        if (this.shareShipList.length > 0) {
          this.params.clientId = this.shareShipList[0].clientId;
        } else {
          this.params.clientId = "";
        }
      });
    },
    fetchShipList() {
      getAdminClientShipList({
        clientId: this.clientId,
        companyId: this.companyId,
        type: this.params.clientType
      }).then(res => {
        if (this.params.clientType == 1) {
          this.shipList = [
            {
              value: "0",
              label: "请选择渔船"
            }
          ];
        } else {
          this.shipList = [
            {
              value: "0",
              label: "暂无"
            }
          ];
        }

        if (res.records.length > 0) {
          const aaa = res.records.map(x => {
            return {
              value: x.id,
              label: x.shipCode
            };
          });
          this.shipList = this.shipList.concat(aaa);
          this.params.shipId = this.shipList[0].value;
          this.shipName = this.shipList[0].label;
        } else {
          this.params.shipId = this.shipList[0].value;
          this.shipName = this.shipList[0].label;
        }
      });
    },
    fetchDetail() {
      useApi(
        getAdminProductDetail({ id: this.$route.params.id }).then(res => {
          this.goods = res;
          this.title1 = "订购数量（" + res.unitName + "）";
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.customer {
  position: fixed;
  top: -10px;
  left: 0;
  z-index: 2;
  width: 100%;
  overflow: hidden;
}
.yufu {
  display: inline-block;
  float: left;
  border: none;
  color: #ff3600;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  width: 200px;
}
.heji {
  display: block;
  overflow: hidden;
  padding: 20px 30px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.x-oilBox {
  position: relative;
  background: #fff;
  margin: 10px 0;
  overflow: hidden;
  .border {
    background: url("../../assets/border.png") repeat;
    height: 1px;
    width: 100%;
  }
}
.middle {
  padding: 20px 30px;
}
.imgBox {
  width: 140px;
  height: 140px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 10px;
  color: #111111;
}
.spec {
  font-size: 12px;
  line-height: 32px;
  color: #919191;
  margin-bottom: 34px;
}
.money {
  font-size: 16px;
  color: #ff3600;
}

.oilMain {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  height: 40px;
  line-height: 40px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100px;
  background: #fff;
  line-height: 100px;
  border-top: 1px solid #e8e8e8;
}
.buyButton {
  width: 220px;
  height: 100px;
  background: #039df8;
  color: #fff;
  font-size: 15px;
  text-align: center;
}
.footerLine1 {
  margin-left: 30px;
  float: left;
}
.uploadImgBox {
  font-size: 14px;
  padding: 20px 30px;
}
.uploadImgBox img {
  margin-top: 20px;
  width: 300px;
  height: 200px;
  display: block;
  overflow: hidden;
}
</style>
